var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseActions } from '../shared/base-actions';
import { Subject } from 'rxjs';
import { KeyDirections } from '../shared/key-directions.enum';
var NavigableComponent = /** @class */ (function (_super) {
    __extends(NavigableComponent, _super);
    function NavigableComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.lastPressed = new Date();
        _this.allowedPressesPerSecond = 4;
        _this.vhValue = 0;
        _this.escapePressed = new Subject();
        _this.playPressed = new Subject();
        _this.forwardPressed = new Subject();
        _this.rewindPressed = new Subject();
        _this.playPressedOnKeyBoard = new Subject();
        _this.fastForwardPressedOnKeyBoard = new Subject();
        _this.backwardPressedOnKeyBoard = new Subject();
        return _this;
    }
    NavigableComponent.prototype.keyEvent = function (event) {
        var now = new Date();
        if ((now.getTime() - this.lastPressed.getTime()) / 1000 > 1 / this.allowedPressesPerSecond) {
            this.lastPressed = now;
            this.handleVideoEvents(event);
            this.navigationService.navigate(event.keyCode);
            this.vhValue = this.navigationService.state.vhValue;
        }
    };
    NavigableComponent.prototype.handleVideoEvents = function (event) {
        this.handleKeyEvent(event, KeyDirections.ESCAPE, this.escapePressed);
        this.handleKeyEvent(event, KeyDirections.PLAY_PAUSE, this.playPressed);
        this.handleKeyEvent(event, KeyDirections.FORWARD, this.forwardPressed);
        this.handleKeyEvent(event, KeyDirections.REWIND, this.rewindPressed);
        this.handleKeyEvent(event, KeyDirections.PLAY_PAUSE_ON_KEYBOARD, this.playPressedOnKeyBoard);
        this.handleKeyEvent(event, KeyDirections.FAST_FORWARD_ON_KEYBOARD, this.fastForwardPressedOnKeyBoard);
        this.handleKeyEvent(event, KeyDirections.REWIND_ON_KEYBOARD, this.backwardPressedOnKeyBoard);
    };
    NavigableComponent.prototype.handleKeyEvent = function (event, direction, subject) {
        if (event.keyCode === direction) {
            subject.next(true);
        }
        else {
            subject.next(false);
        }
    };
    return NavigableComponent;
}(BaseActions));
export { NavigableComponent };
